import request from '@/utils/request'

// 查询首页菜单列表
export function jobList(query) {
  return request({
    url: '/web/menu/joblist',
    method: 'get',
    params: query
  })
}